/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import './ActivitySummaryChart.scss';

import PropTypes from 'prop-types';
import React from 'react';

import { currency } from 'services/Dates';

const ZERO_WIDTH = 4;
const ARROW_WIDTH = 9;
const LABEL_MARGIN = 8;

const SummaryBar = ({ name, max, value, accountDetailsClass }) => {
  let labelPos = { left: '', right: '' };
  const barStyle = {};

  if (value === 0 || typeof value !== 'number' || isNaN(value)) {
    // width = ZERO_WIDTH; // TODO: this was removed because `width` wasn't being used. Was it supposed to be barStyle?
    labelPos.left = ZERO_WIDTH / 2 + LABEL_MARGIN + 'px';
  } else {
    const widthPct = Math.round((Math.abs(value) / max / 2) * 10000) / 100;
    barStyle.width = `calc(${widthPct}%)`;

    if (value < 0) {
      barStyle.left = `calc(50% - ${widthPct}%)`;
      labelPos.right = `calc(100% + ${LABEL_MARGIN + ARROW_WIDTH}px)`;
    } else {
      barStyle.left = 'calc(50% + 1px)';
      labelPos.left = `calc(100% + ${LABEL_MARGIN + ARROW_WIDTH}px)`;
    }
  }

  const signClass = value > 0 ? 'positive' : value < 0 ? 'negative' : '';

  const barClass = `activitySummaryBar ${name.toLowerCase()} arrow ${signClass}`;
  const detailsClass = `activitySummaryDetails${accountDetailsClass} ${name.toLowerCase()}`;
  const nameClass = `activitySummaryDetailName${accountDetailsClass}`;
  const valueClass = `activitySummaryDetailValue${accountDetailsClass} ${signClass}`;

  let nameStyle = value >= 0 ? { textAlign: 'left' } : { textAlign: 'right' };

  return (
    <div className={barClass} style={barStyle}>
      <div className={detailsClass} style={labelPos}>
        <div className={nameClass} style={nameStyle}>
          {name}
        </div>
        <div className={valueClass}>{currency(value)}</div>
      </div>
    </div>
  );
};

class ActivitySummaryChart extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      summary: {
        additions,
        adjustments,
        beginningMarketValue,
        deductions,
        endingMarketValue,
        income,
        marketFluctuation
      },
      hasPershingAccounts = false
    } = this.props;

    const max = Math.max(
      Math.abs(additions),
      Math.abs(adjustments),
      Math.abs(deductions),
      Math.abs(income),
      Math.abs(marketFluctuation)
    );

    // const change = endingMarketValue - beginningMarketValue;
    // const changeClass = ` change${
    //   change > 0 ? ' positive' : change < 0 ? ' negative' : ''
    // }`;

    // const isAccountDetails =
    //   location && location.pathname.includes('account-details');
    // const accountDetailsClass = !isAccountDetails ? '-account-details' : '';
    const accountDetailsClass = '-account-details';

    // const activitySummaryValuesContainerClass = `activitySummaryValuesContainer${accountDetailsClass}`;
    // const activitySummaryLabelClass = `activitySummaryLabel${accountDetailsClass}`;
    // const activitySummaryValueClass = `activitySummaryValue${accountDetailsClass}`;
    // const activitySummaryChangeClass = activitySummaryValueClass + changeClass;

    const activitySummaryValuesContainerClass = `activitySummaryValuesContainer`;
    const activitySummaryLabelClass = `activitySummaryLabel`;
    const activitySummaryValueClass = `activitySummaryValue`;

    return (
      <div id="activity-summary-chart">
        <div className={activitySummaryValuesContainerClass + ' beginning'}>
          <div className={activitySummaryLabelClass}>Beginning balance</div>
          <div className={activitySummaryValueClass + ' beginning'}>
            {currency(beginningMarketValue)}
          </div>
        </div>

        <div className="activitySummaryBars">
          <div className="background-bars">
            <div className="background-bar" />
            <div className="background-bar" />
            <div className="background-bar" />
            <div className="background-bar" />
          </div>
          <SummaryBar
            key="additions"
            name="Additions"
            max={max}
            value={additions}
            accountDetailsClass={accountDetailsClass}
          />
          <SummaryBar
            key="deductions"
            name="Deductions"
            max={max}
            value={deductions}
            accountDetailsClass={accountDetailsClass}
          />
          <SummaryBar
            key="income"
            name="Income"
            max={max}
            value={income}
            accountDetailsClass={accountDetailsClass}
          />
          {hasPershingAccounts && (
            <SummaryBar
              key="adjustments"
              name="Adjustments"
              max={max}
              value={adjustments}
              accountDetailsClass={accountDetailsClass}
            />
          )}
          <SummaryBar
            key="fluctuation"
            name="Market Fluctuation"
            max={max}
            value={marketFluctuation}
            accountDetailsClass={accountDetailsClass}
          />
        </div>

        <div className={activitySummaryValuesContainerClass + ' ending'}>
          <div className={activitySummaryLabelClass}>Ending balance</div>
          <div className={activitySummaryValueClass + ' ending'}>
            {currency(endingMarketValue)}
          </div>
        </div>
      </div>
    );
  }
}

ActivitySummaryChart.propTypes = {
  summary: PropTypes.objectOf(PropTypes.number),
  hasPershingAccounts: PropTypes.bool
};

export default ActivitySummaryChart;
